<!-- =========================================================================================
  File Name: Profile.vue
  Description: Profile Page
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="profile-page">
        <!-- COL AREA -->
        <div class="vx-row" v-if="inscription">
            <!-- COL 1 -->
            <div class="vx-col w-full lg:w-1/4">
                <!-- ABOUT CARD -->
                <vx-card :title="$t('Parent_or_guardian')" class="mt-base" v-for="(parent, index) in inscription.eleve.parents_add" :key="index">
                    <!-- ACTION SLOT -->
                    <template slot="actions">
                        <feather-icon icon="MoreHorizontalIcon"></feather-icon>
                    </template>
                    <!-- OTEHR DATA -->
                    <div class="mt-5">
                        <h6>{{$t('Full_name')}} </h6>
                        <p>{{parent.full_name}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>{{$t('Address')}}</h6>
                        <p>{{parent.adresse}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>{{$t('Sex')}}</h6>
                        <p>{{parent.sexe.libelle}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>{{$t('Phone_number_1')}}</h6>
                        <p>{{parent.telephone1}}</p>
                    </div>

                    <div class="mt-5">
                        <h6>{{$t('Phone_number_2')}}</h6>
                        <p>{{parent.telephone2}}</p>
                    </div>
                </vx-card>
            </div>

            <!-- COL 2 -->
            <div class="vx-col w-full lg:w-1/2">
                <vx-card class="mt-base" :title="$t('Personal_information')">
                    <div>
                        <!-- POST HEADER -->
                        <div class="post-header flex justify-between mb-4">
                            <div class="flex items-center">
                                <div>
                                    <vs-avatar class="m-0" :src="userLatestPhotos[0]" size="45px"></vs-avatar>
                                </div>
                                <div class="ml-4">
                                    <h6>{{inscription.eleve.full_name}}</h6>
                                    <small>{{ inscription.eleve.matricule }}</small>
                                </div>
                            </div>
                        </div>

                        <!-- POST CONTENT -->
                        <div class="post-content">
                          <div class="mt-5">
                              <h6>{{$t('Date_of_Birth')}}</h6>
                              <p>{{inscription.eleve.naissance}}</p>
                          </div>
                          <div class="mt-5">
                              <h6>{{$t('Address')}}</h6>
                              <p>{{inscription.eleve.adresse}}</p>
                          </div>

                          <div class="mt-5">
                              <h6>{{$t('Contact')}}</h6>
                              <p>{{inscription.eleve.contact}}</p>
                          </div>

                          <div class="mt-5">
                              <h6>{{$t('Entry_date')}}</h6>
                              <p>{{inscription.eleve.dateEntree}}</p>
                          </div>

                          <div class="mt-5">
                              <h6>{{$t('Abandoned')}}</h6>
                              <p>{{(inscription.eleve.have_abandoned? 'OUI' : 'NON')}}</p>
                          </div>
                        </div>
                    </div>
                </vx-card>
            </div>

            <!-- COL 3 -->
            <div class="vx-col w-full lg:w-1/4">

                <!-- LATEST PHOTOS -->
                <vx-card :title="$t('School_information')" class="mt-base">
                    <div class="vx-row pt-2">

                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
let base_self = ''
export default {
  data () {
    return {
      inscription: null,
      userLatestPhotos: [require('@/assets/images/profile/user-uploads/user-01.jpg')]
    }
  },
  computed: {
  },
  methods: {
    getParent (input) {
      const data = {
        is_get: true,
        filter: { eleves__inscriptions__id: input.id }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Parent`, data)
        .then((response) => {
          input.eleve.parents_add = JSON.parse(
            JSON.stringify(response.data.data),
          )

          base_self.inscription = JSON.parse(JSON.stringify(input))
        })
        .catch((error) => {
          console.error(' -------- ', error)
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    getInscriptionOne (id) {
      const data = {
        is_get: true,
        filter: { id }
      }
      base_self.$http
        .post(`${base_self.$store.state.route_for_esm}Inscription`, data)
        .then((response) => {
          const input = JSON.parse(JSON.stringify(response.data.data[0]))
          console.log('input', input)
          base_self.getParent(input)
        })
        .catch((error) => {
          console.error(' -------- ', error)
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    }
  },
  components: {
  },
  created () {
    base_self = this
    const id = Number(base_self.$route.params.id)
    if (id !== 0) {
      base_self.getInscriptionOne(id)
    }
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
</style>
